import { Directive } from '@angular/core';

@Directive({ selector: 'tr-accordion-header' })
export class TrAccordionHeader {}
